/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IDobbiesAddProductToCartData } from './dobbies-add-product-to-cart.data';
import { IDobbiesAddProductToCartProps } from './dobbies-add-product-to-cart.props.autogenerated';

export interface IDobbiesAddProductToCartViewProps extends IDobbiesAddProductToCartProps<IDobbiesAddProductToCartData> {}

/**
 *
 * DobbiesAddProductToCart component
 * @extends {React.PureComponent<IDobbiesAddProductToCartProps<IDobbiesAddProductToCartData>>}
 */
class DobbiesAddProductToCart extends React.PureComponent<IDobbiesAddProductToCartProps<IDobbiesAddProductToCartData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default DobbiesAddProductToCart;
